import { render, staticRenderFns } from "./Contacto-mod.vue?vue&type=template&id=57ef4802"
import script from "./Contacto-mod.vue?vue&type=script&lang=js"
export * from "./Contacto-mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports